import moment from "moment";
import ChartDataLabels from 'chartjs-plugin-datalabels';
export const basicOptions = {
  maintainAspectRatio: false,
  legend: {
    display: false
  },
  responsive: true,
};
export const lineChartOptions = {
  ...basicOptions,
  plugins: {
    // Change options for ALL labels of THIS CHART
    datalabels: {
      labels: {
        title: null
      }
    }
  },
  legend: {
    display: true,
    position: "bottom",
    labels: {
      usePointStyle: true,
      fontColor: 'rgb(255, 255, 255,0.5)'
    }
  },
  tooltips: {
    backgroundColor: '#f5f5f5',
    titleFontColor: '#333',
    bodyFontColor: '#666',
    bodySpacing: 4,
    xPadding: 12,
    mode: 'nearest',
    intersect: 0,
    position: 'nearest',
    callbacks: {
      label: (tooltipItems, data) => {
        //console.log(data, tooltipItems);
        var n = tooltipItems.yLabel;
        //check for float data then don't apply comma(,) foramt
        if (n === +n && n !== (n | 0))
          return data.datasets[tooltipItems.datasetIndex].label + " " + tooltipItems.yLabel;

        return data.datasets[tooltipItems.datasetIndex].label + " " + tooltipItems.yLabel.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      }
    },
  },
  scales: {
    yAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: 'rgba(29,140,248,0.0)',
          zeroLineColor: 'transparent'
        },
        ticks: {
          suggestedMin: 60,
          suggestedMax: 125,
          padding: 20,
          fontColor: '#9a9a9a',
        }
      }
    ],

    xAxes: [
      {
        type: 'time',
        ticks: {
          min: moment("2020-03-09").format(),
          max: moment().format(),
        },
        time: {
          unit: 'month',
          displayFormats: {
            month: 'MMM'
          }
        },
        scaleLabel: {
          display: true,
          labelString: 'Date'
        },
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: 'rgba(225,78,202,0.1)',
          zeroLineColor: 'transparent'
        },
        ticks: {
          padding: 20,
          fontColor: '#9a9a9a'
        }
      }
    ]
  }
};

export const lineChartTopOptions = {
  ...basicOptions,
  plugins: {
    // Change options for ALL labels of THIS CHART
    datalabels: {
      labels: {
        title: null
      }
    }
  },
  legend: {
    display: false,
    position: "bottom",
    labels: {
      usePointStyle: true,
      fontColor: 'rgb(255, 255, 255,0.5)'
    }
  },
  tooltips: {
    backgroundColor: '#f5f5f5',
    titleFontColor: '#333',
    bodyFontColor: '#666',
    bodySpacing: 4,
    xPadding: 12,
    mode: 'nearest',
    intersect: 0,
    position: 'nearest',
    callbacks: {
      label: (tooltipItems, data) => {
        //console.log(data, tooltipItems);
        var n = tooltipItems.yLabel;
        //check for float data then don't apply comma(,) foramt
        if (n === +n && n !== (n | 0))
          return data.datasets[tooltipItems.datasetIndex].label + " " + tooltipItems.yLabel;

        return data.datasets[tooltipItems.datasetIndex].label + " " + tooltipItems.yLabel.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      }
    },
  },
  scales: {
    yAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: 'rgba(29,140,248,0.0)',
          zeroLineColor: 'transparent'
        },
        ticks: {
          suggestedMin: 60,
          suggestedMax: 125,
          padding: 20,
          fontColor: '#9a9a9a',
        }
      }
    ],

    xAxes: [
      {
        type: 'time',
        ticks: {
          min: moment("2020-03-09").format(),
          max: moment().format(),
        },
        time: {
          unit: 'month',
          displayFormats: {
            month: 'MMM'
          }
        },
        scaleLabel: {
          display: true,
          labelString: 'Date'
        },
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: 'rgba(225,78,202,0.1)',
          zeroLineColor: 'transparent'
        },
        ticks: {
          padding: 20,
          fontColor: '#9a9a9a'
        }
      }
    ]
  }
};


export let barChartOptions = {
  legend: {
    display: false
  },
  intersect: true,
  animation: {
    duration: 15
  },
  legend: {
    display: false,
    position: "bottom",
    align: "start",
    labels: {
      usePointStyle: true,
      fontColor: 'rgb(255, 255, 255,0.5)',
      filter: function (item, chart) {
        // Logic to remove a particular legend item goes here
        return typeof item.text !== "undefined";
      }
    },
  },
  tooltips: {
    enabled: false,
    mode: 'index',
    position: 'nearest',
    filter: function (tooltipItems, data) {
      var num = tooltipItems.yLabel;
      if (typeof num === "string" || num instanceof String)
        return false;

      return true;
    },
    custom: function (tooltip) {
      // Tooltip Element
      var tooltipEl = document.getElementById('chartjs-tooltip');
      if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.id = 'chartjs-tooltip';
        tooltipEl.innerHTML = "<table></table>"
        document.body.appendChild(tooltipEl);
      }
      // Hide if no tooltip
      if (tooltip.opacity === 0) {
        tooltipEl.style.opacity = 0;
        return;
      }
      // Set caret Position
      tooltipEl.classList.remove('above', 'below', 'no-transform');
      if (tooltip.yAlign) {
        tooltipEl.classList.add(tooltip.yAlign);
      } else {
        tooltipEl.classList.add('no-transform');
      }
      function getBody(bodyItem) {
        return bodyItem.lines;
      }
      function convert_positive(a) {
        // Check the number is negative 
        if (a < 0) {
          // Multiply number with -1 
          // to make it positive 
          a = a * -1;
        }
        // Return the positive number 
        return a;
      }
      // Set Text
      if (tooltip.body) {
        var titleLines = tooltip.title || [];
        var bodyLines = tooltip.body.map(getBody);
        //PUT CUSTOM HTML TOOLTIP CONTENT HERE (innerHTML)
        var innerHtml = '<tbody>';
        var newBody = tooltip.dataPoints[0].label.split("~");
        var valueOrigianl = newBody[1];
        var formatValue = "";
        if (parseFloat(valueOrigianl) >= 1) {
          formatValue = "<span style='color:#ff0000'>" + valueOrigianl + "</span>";
        } else {
          formatValue = "<span style='color:#00ff00'>" + valueOrigianl + "</span>";
        }
        innerHtml += '<tr><td><b>' + newBody[0] + ' R<sub>t</sub></b></td></tr>';
        innerHtml += '<tr><td><b>' + formatValue + '</b> Estimate</td></tr>';
        innerHtml += '<tr><td><span style="color:#aaa"><b>' + convert_positive(parseFloat(newBody[2]).toFixed(2)) + "-" + convert_positive(parseFloat(newBody[3]).toFixed(2)) + '</b></span> Range</td></tr>';
        innerHtml += '</tbody>';
        var tableRoot = tooltipEl.querySelector('table');
        tableRoot.innerHTML = innerHtml;
      }
      var position = this._chart.canvas.getBoundingClientRect();
      // Display, position, and set styles for font
      tooltipEl.style.opacity = 1;
      tooltipEl.style.fontFamily = "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif";
      tooltipEl.style.fontStyle = "normal";
      tooltipEl.style.left = position.left + tooltip.caretX + 'px';
      tooltipEl.style.top = position.top + tooltip.caretY - 80 + 'px';
      tooltipEl.style.padding = tooltip.yPadding + 'px ' + tooltip.xPadding + 'px';
    }
    /*     callbacks: {
          labelColor: function (tooltipItems, chart) {
            if (tooltipItems.yLabel >= 1) {
              return {
                backgroundColor: 'rgb(255, 0, 0)'
              }
            }
            return {
              backgroundColor: 'rgb(0, 255, 0)'
            }
    
          },
          label: (tooltipItems, data) => {
            console.log(tooltipItems,data);
            console.log("===",data.datasets[1].data[tooltipItems.datasetIndex]);
            return tooltipItems.yLabel;
          }
        }, */
  },
  scales: {
    yAxes: [
      {
        stacked: false,
        scaleLabel: {
          display: true,
          labelString: "Effective Reproduction Number"
        },
        gridLines: {
          drawBorder: false,
          color: 'rgba(29,140,248,0.1)',
          zeroLineColor: 'transparent'
        },
        ticks: {
          // min: 0,
          // max: 2,
          suggestedMin: 0,
          suggestedMax: 2,
          stepSize: 0.2,
          padding: 20,
          fontColor: '#9e9e9e'
        }
      }
    ],
    xAxes: [
      {
        stacked: true,
        gridLines: {
          drawBorder: false,
          color: 'rgba(29,140,248,0.1)',
          zeroLineColor: 'transparent'
        },
        ticks: {
          display: false,
          padding: 20,
          fontColor: '#9e9e9e'
        }
      }
    ]
  },
  annotation: {
    drawTime: 'beforeDatasetsDraw',
    annotations: [{
      type: 'line',
      mode: 'horizontal',
      scaleID: 'y-axis-0',
      value: 1,
      borderColor: 'rgb(255, 0, 0)',
      borderWidth: 1,
      label: {
        enabled: false,
        content: 'Test label'
      }
    }]
  },
  events: ['mousemove', 'mouseout', 'touchmove', 'click'], // this is needed, otherwise onHover is not fired
  onHover: (event, chartElement) => {
    event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
  },
};


export const rtLineChartOptions = {
  ...basicOptions,
  plugins: {
    // Change options for ALL labels of THIS CHART
    datalabels: {
      labels: {
        title: null
      }
    }
  },
  legend: {
    display: false,
    position: "bottom",
    labels: {
      usePointStyle: true,
      fontColor: 'rgb(255, 255, 255,0.5)'
    }
  },
  tooltips: {
    backgroundColor: '#f5f5f5',
    titleFontColor: '#333',
    bodyFontColor: '#666',
    bodySpacing: 4,
    xPadding: 12,
    mode: 'point',
    intersect: 0,
    position: 'nearest',
    callbacks: {
      label: (tooltipItems, data) => {
        //console.log(data, tooltipItems);
        var n = tooltipItems.yLabel;
        //check for float data then don't apply comma(,) foramt
        if (n === +n && n !== (n | 0))
          return data.datasets[tooltipItems.datasetIndex].label + " " + tooltipItems.yLabel;

        return data.datasets[tooltipItems.datasetIndex].label + " " + tooltipItems.yLabel.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      }
    },
  },
  scales: {
    yAxes: [
      {
        id: 'rt',
        type: 'linear',
        position: 'right',
        ticks: {
          fontColor: '#9a9a9a',
          beginAtZero: true,
          callback: function (value, index, values) {
            return value;
          }
        },
        display: false,
        scaleLabel: {
          display: true,
          labelString: "Rt"
        },
      },
      {
        id: 'positive',
        position: 'left',
        display: true,
        scaleLabel: {
          display: true,
          labelString: "New Cases"
        },
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: 'rgba(29,140,248,0.0)',
          zeroLineColor: 'transparent'
        },
        ticks: {
          padding: 20,
          fontColor: '#9a9a9a',
          beginAtZero: true,
          callback: function (value, index, values) {
            return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
          }
        }
      }
    ],

    xAxes: [
      {
        type: 'time',
        ticks: {
          min: moment("2020-03-09").format(),
          max: moment().format(),
        },
        time: {
          unit: 'month',
          displayFormats: {
            month: 'MMM'
          }
        },
        scaleLabel: {
          display: true,
          labelString: 'Date'
        },
        barPercentage: 0.4,
        gridLines: {
          drawBorder: false,
          color: 'rgba(225,78,202,0.1)',
          zeroLineColor: 'transparent'
        },
        ticks: {
          padding: 20,
          fontColor: '#9a9a9a'
        }
      }
    ]
  }
};


export const ecomomicLineChartOptions = {
  ...basicOptions,
  plugins: {
    // Change options for ALL labels of THIS CHART
    datalabels: {
      labels: {
        title: null
      }
    }
  },
  legend: {
    display: true,
    position: "bottom",
    labels: {
      usePointStyle: true,
      fontColor: 'rgb(255, 255, 255,0.5)'
    }
  },
  tooltips: {
    backgroundColor: '#f5f5f5',
    titleFontColor: '#333',
    bodyFontColor: '#666',
    bodySpacing: 4,
    xPadding: 12,
    mode: 'nearest',
    axis: "xy",
    intersect: false,
    callbacks: {
      label: (tooltipItems, data) => {
        //console.log(data, tooltipItems);
        var n = tooltipItems.yLabel;
        //check for float data then don't apply comma(,) foramt
        if (n === +n && n !== (n | 0))
          return data.datasets[tooltipItems.datasetIndex].label + " " + tooltipItems.yLabel;

        return data.datasets[tooltipItems.datasetIndex].label + " " + tooltipItems.yLabel.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      }
    },
  },
  scales: {
    yAxes: [
      {
        id: 'unemploymentrates',
        position: 'right',
        ticks: {
          fontColor: '#9a9a9a',
          beginAtZero: true,
          callback: function (value, index, values) {
            return value;
          }
        },
        display: false,
      },
      {
        id: 'positive',
        position: 'left',
        display: true,
        scaleLabel: {
          display: true,
          labelString: "Claims"
        },
        ticks: {
          padding: 20,
          fontColor: '#9a9a9a',
          beginAtZero: true,
          callback: function (value, index, values) {
            return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
          }
        }
      }
    ],

    xAxes: [
      {
        type: 'time',
        ticks: {
          min: moment("2020-03-09").format(),
          max: moment().format(),
        },
        time: {
          unit: 'month',
          displayFormats: {
            month: 'MMM'
          }
        },
        scaleLabel: {
          display: true,
          labelString: 'Date'
        },
        gridLines: {
          drawBorder: false,
          color: 'rgba(225,78,202,0.1)',
          zeroLineColor: 'transparent'
        },
        ticks: {
          padding: 20,
          fontColor: '#9a9a9a'
        }
      }
    ]
  }
};

export let removeState = [
  "American Samoa",
  "Guam",
  "Northern Mariana Islands",
  "Puerto Rico",
  "Virgin Islands",
  "District of Columbia",
];


export let colorOptions = {
  color: {
    "Alabama": "#CCCC00",
    "Alaska": "#E666B3",
    "American Samoa": "#608fa4",
    "Arizona": "#FFFF99",
    "Arkansas": "#1AB399",
    "California": "#00B3E6",
    "Colorado": "#FF1A66",
    "Connecticut": "#FF3380",
    "Delaware": "#E666FF",
    "District of Columbia": "#CCFF1A",
    "Florida": "#E6B333",
    "Georgia": "#3366E6",
    "Guam": "#76fc1b",
    "Hawaii": "#999933",
    "Idaho": "#809980",
    "Illinois": "#999966",
    "Indiana": "#33991A",
    "Iowa": "#CC80CC",
    "Kansas": "#991AFF",
    "Kentucky": "#66664D",
    "Louisiana": "#E6FF80",
    "Maine": "#1AFF33",
    "Maryland": "#FF99E6",
    "Massachusetts": "#dba2e6",
    "Michigan": "#FF33FF",
    "Minnesota": "#4DB3FF",
    "Mississippi": "#FF4D4D",
    "Missouri": "#66E64D",
    "Montana": "#4D80CC",
    "Nebraska": "#E6331A",
    "Nevada": "#B33300",
    "New Hampshire": "#66991A",
    "New Jersey": "#33FFCC",
    "New Mexico": "#4D8066",
    "New York": "#B34D4D",
    "North Carolina": "#99FF99",
    "North Dakota": "#6666FF",
    "Northern Mariana Islands": "#20f6ba",
    "Ohio": "#4D8000",
    "Oklahoma": "#99E6E6",
    "Oregon": "#80B300",
    "Pennsylvania": "#00E680",
    "Puerto Rico": "#dce77a",
    "Rhode Island": "#FFB399",
    "South Carolina": "#809900",
    "South Dakota": "#4DB380",
    "Tennessee": "#66994D",
    "Texas": "#E6B3B3",
    "Utah": "#E64D66",
    "Vermont": "#B3B31A",
    "Virgin Islands": "#07d7f6",
    "Virginia": "#B366CC",
    "Washington": "#FF6633",
    "West Virginia": "#CC9999",
    "Wisconsin": "#6680B3",
    "Wyoming": "#9900B3"
  }
};

export let states_hash =
{
  'Alabama': 'AL',
  'Alaska': 'AK',
  'American Samoa': 'AS',
  'Arizona': 'AZ',
  'Arkansas': 'AR',
  'California': 'CA',
  'Colorado': 'CO',
  'Connecticut': 'CT',
  'Delaware': 'DE',
  'District of Columbia': 'DC',
  'Federated States Of Micronesia': 'FM',
  'Florida': 'FL',
  'Georgia': 'GA',
  'Guam': 'GU',
  'Hawaii': 'HI',
  'Idaho': 'ID',
  'Illinois': 'IL',
  'Indiana': 'IN',
  'Iowa': 'IA',
  'Kansas': 'KS',
  'Kentucky': 'KY',
  'Louisiana': 'LA',
  'Maine': 'ME',
  'Marshall Islands': 'MH',
  'Maryland': 'MD',
  'Massachusetts': 'MA',
  'Michigan': 'MI',
  'Minnesota': 'MN',
  'Mississippi': 'MS',
  'Missouri': 'MO',
  'Montana': 'MT',
  'Nebraska': 'NE',
  'Nevada': 'NV',
  'New Hampshire': 'NH',
  'New Jersey': 'NJ',
  'New Mexico': 'NM',
  'New York': 'NY',
  'North Carolina': 'NC',
  'North Dakota': 'ND',
  'Northern Mariana Islands': 'MP',
  'Ohio': 'OH',
  'Oklahoma': 'OK',
  'Oregon': 'OR',
  'Palau': 'PW',
  'Pennsylvania': 'PA',
  'Puerto Rico': 'PR',
  'Rhode Island': 'RI',
  'South Carolina': 'SC',
  'South Dakota': 'SD',
  'Tennessee': 'TN',
  'Texas': 'TX',
  'Utah': 'UT',
  'Vermont': 'VT',
  'Virgin Islands': 'VI',
  'Virginia': 'VA',
  'Washington': 'WA',
  'West Virginia': 'WV',
  'Wisconsin': 'WI',
  'Wyoming': 'WY'
}